import type { ReactNode } from "react";
import { Progress } from "../../../../../../../../shared/frontend/ui";
import { OperationValue } from "../../../../../../../../shared/frontend/operations/OperationValue";
import type { useFinanceOperation } from "../../../../app/operations/useFinanceOperation";
import "../personOverview.css";

export type OverviewKpiTone = "ok" | "warn" | "error" | "neutral";
export type OverviewValueOperation = Pick<ReturnType<typeof useFinanceOperation>, "entry" | "retry"> & { retryLabel: string; errorLabel: string };

/**
 * Eine Kennzahl der Personenübersicht — die eine Schriftskala aller Blöcke: Beschriftung, Wert, höchstens eine
 * Zusatzzeile; Zahlen und Wörter in derselben Größe. Farbe nur bei Abweichung (`tone`). `progress` zeichnet
 * unter dem Wert einen Balken (z. B. vergangene Laufzeit).
 */
export function OverviewKpi({ label, children, sub, tone = "neutral", progress, progressLabel, operation }: {
  label: ReactNode;
  children: ReactNode;
  sub?: ReactNode;
  tone?: OverviewKpiTone;
  progress?: number;
  progressLabel?: string;
  operation?: OverviewValueOperation;
}) {
  return (
    <div className="person-overview-kpi" data-tone={tone}>
      <span className="person-overview-kpi-label">{label}</span>
      <span className="person-overview-kpi-value">
        {operation ? <OperationValue entry={operation.entry} retry={operation.retry} retryLabel={operation.retryLabel} errorLabel={operation.errorLabel}>{children}</OperationValue> : children}
      </span>
      {progress != null ? <Progress showInfo={false} percent={progress} aria-label={progressLabel} /> : null}
      {sub ? <span className="person-overview-kpi-sub" style={{ visibility: operation?.entry ? "hidden" : undefined }} aria-hidden={operation?.entry ? true : undefined}>{sub}</span> : null}
    </div>
  );
}
